import { faro } from '@gate31/faro/src';

export class DeduplicateTraficSource {
    static daysToStore = 365;

    // Параметр ссылки в котором лежим источник трафика из адмитада
    static sourceParamName = 'utm_source'

    // Кука в которую ложим источник трафика
    static cookieName = 'deduplication_cookie'

    // https://shop-64875-43.myinsales.ru/admin2/fields/8424683/edit?destiny=3
    static insalesFieldId = 93590817

    constructor() {}

    private static getParamFromUrl(paramName: string) {
        const regex = new RegExp('[?&]' + paramName + '=([^&#]*)');
        const results = regex.exec(window.location.search);

        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    }

    private static setCookie(name: string, value: string, days: number) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        const cookieBase = `${name}=${value}; path=/; expires=${expires}; SameSite=Lax`;

        // Установка cookie для текущего домена
        document.cookie = cookieBase;
    }

    private static getCookie(name: string): string | null {
        const nameEQ = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const c = cookies[i].trim();

            if (c.startsWith(nameEQ)) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    }

    // Для каждой страницы магазина
    static setDeduplicateCookie() {
        const uid = DeduplicateTraficSource.getParamFromUrl(DeduplicateTraficSource.sourceParamName);

        if (! uid) return;

        DeduplicateTraficSource.setCookie(DeduplicateTraficSource.cookieName, uid, DeduplicateTraficSource.daysToStore);
    }

    // Для страница оформления заказа
    static setDeduplicateValueFromInsalesField() {
        const uidValue = DeduplicateTraficSource.getCookie(DeduplicateTraficSource.cookieName);

        if (! uidValue) return;

        // Получить поле
        const currentField = document.querySelector<HTMLInputElement>(`[name="order[fields_values_attributes][${DeduplicateTraficSource.insalesFieldId}][value]"]`);

        if (! currentField) {
            faro.api.pushError(new Error('Not fund admitad field on chackout page'), {
                context: {
                    section: 'ADMITAD'
                }
            });

            return;
        }

        // Записываем значение
        currentField.value = uidValue;
    }
}

